<template>
  <table
    v-editable="editing && blok"
    class="sb-table text-[12px] xl:text-base"
    role="table"
    :class="[...layout_classes]"
    :name="blok.id"
  >
    <thead>
      <tr>
        <th
          v-for="(th, k) in blok.table.thead"
          :key="k"
          class=" p-3 lg:p-4 lg:pl-8"
          v-html="marked.parse(th.value)"
        ></th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="(tr, trk) in blok.table.tbody"
        :key="trk"
        :class="
          [(tr.body[0]?.value.indexOf('[inherit-parent]') == -1
            ? 'odd:bg-[#F4F4F4] even:bg-[#EEEEEE]'
            : 'odd:bg-[#EEEEEE] even:bg-[#F4F4F4]'),
            ...checkRelations(tr.body[0].value)
          ]
            
        "
      >
        <td
          v-for="(td, tdk) in tr.body"
          :key="tdk"
          v-html="marked.parse(removeExtras(td.value))"
          class="p-3 lg:p-4 lg:pl-8"
          :header="blok.table.thead[tdk].value"
          :class="`before:content-[attr(header)]`"
        ></td>
      </tr>
    </tbody>
  </table>
</template>
<style lang="scss">
.sb-table {
  width: 100%;
  max-width: 100%;
  &.rounded {
    border-radius: 10px;
    overflow: hidden;
    @include breakpoint(lg) {
      border-radius: 10px;
    }
  }
  thead {
    display: table-header-group;
    tr {
      th {
        display: table-cell;
      }
    }
  }
  th,
  td {
    text-align: left;
    min-width: 100px;
  }
  tbody,
  thead {
    tr {
      td,
      th {
        // vertical-align: top;
        p {
          margin: 0px;
        }
      }
    }
  }
  text-align: left;
  // thead{
  //       display: table-header-group;
  // }
  // tbody{
  //       display: table-row-group;
  // }
  // tr{
  //   display: table-row;
  //   th{
  //     display: table-cell;
  //   }
  // }
  &.temperature-excursion {
    // table-layout: auto;width: 100%;

    thead {
      background-color: $c-purple-40;
      display: none;
      
    }
     @include breakpoint-max(md){
      tr{
        display: flex;
        flex-direction: column;
        margin-bottom:1rem;
        border-radius: 5px;
        &[class*="has-children"]{
          border-bottom-left-radius:0px ;
          border-bottom-right-radius:0px ;
           margin-bottom:0rem;
           +tr{
            border-top-left-radius:0px ;
            border-top-right-radius:0px ;
          }
           &[class*="has-children-2"]{
            +tr{
                margin-bottom:0rem;
               border-radius: 0px;
               &::before{
                
               }
                td:first-child::before{
                  content:''
                }
                td:first-child{
                  font-weight: bold;
                }
                +tr{
                  td:first-child::before{
                    content:''
                  }
                    td:first-child{
                  font-weight: bold;
                }
                  border-top-left-radius:0px ;
                  border-top-right-radius:0px ;
                }
            }
           }
        }
        overflow: hidden;
        

      }
      td{
        padding:0px;
        display: flex;
        &::before{
          padding:6px;
          display: flex;
          align-items: center;
          width:45%;
          font-weight: bold;
          padding:.75rem;
          vertical-align: middle;
          background-color: $c-purple-40;
        }
        >*{
          // display: inline-block;
          width:45%;
          padding:.75rem;
          flex-grow:1;
            display: table-cell;
           vertical-align: middle;
        }
        &:nth-child(odd){
          background-color: #F4F4F4;

        }
        &:nth-child(even){
          background-color: #EEE;

        }
      }
     }
    @include breakpoint(md){
      thead {
        
        display: table-header-group;
      }
      td{
        &::before{
          display: none;
        }
      }
    }
  }
}
</style>
<script setup>
import { marked } from "marked";
const {editing} = useSettings()
const { getLayoutClasses } = useLayoutControl();
const { blok } = defineProps({ blok: Object });
const layout_classes = getLayoutClasses(blok);
function checkRelations(markdown) {
  const regex = /\[has-children-(.*?)\]/;
  const match = markdown.match(regex);
  let ret = []
  if (match) {
    ret.push('has-children-'+match[1])
  }
  return ret
}
function removeExtras(markdown) {
  // console.log(markdown.match(/\[is-parent-(\d+)\]/gm))
  return markdown.replace("[inherit-parent]", "").replace(/\[has-children-(\d+)\]/gm,'').replace(/\[has-parent-(\d+)\]/gm,'');
}
//  useI18n();
// console.log(blok.table)
</script>
